/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { Container } from 'semantic-ui-react';
import Language from '../containers/Language';

const StyledContainer = styled(Container)`
  align-items: center;
  justify-content: center;
  display: flex !important;
  min-height: 100dvh;
  padding: 70px 0;
`;

const Content = styled.div`
  width: 500px;
`;

const Header = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 16px 60px;
  display: flex;
  justify-content: flex-end;
  z-index: 2;

  @media screen and (max-width: 767px) {
    padding-right: 2em;
  }
`;

const HeaderLanguage = styled.div`
  border: 1px solid rgba(142, 142, 147, 0.5);
  background: #fff;
  border-radius: 999px;
  padding: 12px 14px;
`;

const AuthLayout = ({ children }) => (
  <StyledContainer fluid>
    <Header>
      <HeaderLanguage>
        <Language position="left" />
      </HeaderLanguage>
    </Header>
    <Content>{children}</Content>
  </StyledContainer>
);

export default AuthLayout;
